import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";

export default function RequireAuth({ children, requireOnboarded = true }) {
  const { user, profile, booted } = useAuth();
  const location = useLocation();

  if (!booted) {
    return (
      <div className="min-h-screen grid place-items-center bg-black">
        <div className="w-10 h-10 border-2 border-neon/30 border-t-neon rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Enforce onboarding completion flag on the public profile, not just any
  // presence of country. This prevents half-finished profiles from bypassing.
  if (requireOnboarded && !profile?.completed_onboarding) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
